import React, { useState, useContext } from 'react';
import { Button, Loader, toasterService, Banner } from 'components';
import { WorkingAsContext } from 'context/working-as-context';
import { submitCustomerProfile, verifyCustomerProfile } from 'shared/common.api';
export const SubmitStep = props => {
  const {
    profile,
    setActiveStep,
    verification,
    setVerification
  } = props;
  const {
    asCompany
  } = useContext(WorkingAsContext);
  const [isSaving, setIsSaving] = useState(false);
  const submit = () => {
    // Submit this to the Cinch API which will submit to the Twilio API...
    // This will not be stored in Cinch's database but will be retrieved directly from Twilio
    setIsSaving(true);
    if (profile?.business_information?.business_registration_identifier === 'EIN' && profile?.business_information?.business_registration_number.replace('-', '').length != 9) {
      setVerification({
        status: 'noncompliant',
        steps: {
          customer_profile_business_information: {
            passed: false,
            error: {
              business_registration_number: 'EIN must be 9 digits'
            }
          }
        }
      });
      setIsSaving(false);
      return;
    }
    verifyCustomerProfile(asCompany.id).then(({
      data
    }) => {
      setVerification({
        ...data,
        steps: data.results.reduce((res, row) => {
          res[row.requirement_name] = {
            error: row.fields.reduce((res, field) => {
              if (field.passed === false) {
                res[field.object_field] = field.failure_reason;
              }
              return res;
            }, {}),
            passed: row.passed
          };
          return res;
        }, {})
      });
      if (data.status === 'compliant') {
        return submitCustomerProfile(asCompany.id);
      }
    }).then(() => setActiveStep(profile.trust_bundle_status === 'in-review' ? 5 : 4)).catch(() => {
      toasterService.error('There was an unknown error trying to save your profile. Check your inputs and try again');
    }).then(() => {
      setIsSaving(false);
    });
  };
  if (profile.status === 'in-review') {
    return <>
        {profile.status === 'in-review' && <Banner type="info" className="my-3">
            Your application is currently in review.
          </Banner>}

        <div style={{
        display: 'flex',
        gap: '10px',
        justifyContent: 'end'
      }}>
          <Button actionType="primary" disabled={isSaving} onClick={() => setActiveStep(profile.trust_bundle_status === 'in-review' ? 5 : 4)}>
            Next
          </Button>
        </div>
      </>;
  }
  return <>
      {verification?.status === 'noncompliant' && <Banner type="warning" className="mb-3">
          Some of the information submitted is not valid. Please fix the errors and try again.
        </Banner>}
      <div style={{
      display: 'flex',
      gap: '10px',
      justifyContent: 'end'
    }}>
        <Button actionType="flat" onClick={() => setActiveStep(2)}>
          Back
        </Button>
        <Button actionType="primary" disabled={isSaving} onClick={submit}>
          Submit {isSaving && <Loader className="ml-3" size="sm" />}
        </Button>
      </div>
    </>;
};